// Redux
import { combineReducers } from 'redux';

import request from './request';
import viewGoalcard from './viewGoalcard';
import publicProfile from './publicProfile';
import selectCard from './selectCard';
import gift from './gift';
import publicGoal from './publicGoal';
import customize from './customize';
import purchase from './purchase';

// Root Reducer
const rootReducer = combineReducers({
  request,
  viewGoalcard,
  publicProfile,
  selectCard,
  gift,
  publicGoal,
  customize,
  purchase,
});

export default rootReducer;
